import { QueryResult, gql } from "@outschool/ui-apollo";
import {
  ActivityListingFragment,
  usePaginatedQuery,
} from "@outschool/ui-components-website";

import {
  EnrollmentHistoryQuery,
  EnrollmentHistoryQueryVariables,
} from "../../shared/generated/graphql";

const enrollmentHistoryQuery = gql`
  query EnrollmentHistory(
    $uid: ID!
    $offset: Int
    $skipRating: Boolean!
    $profileLinkUid: String
    $publicView: Boolean
  ) {
    pastEnrollmentsForParentProfile(
      userUid: $uid
      offset: $offset
      profileLinkUid: $profileLinkUid
      publicView: $publicView
    ) {
      ...ActivityListing_listing
    }
  }
  ${ActivityListingFragment}
`;

export type EnrollmentHistoryQueryOptions = {
  variables: EnrollmentHistoryQueryVariables;
};

const getItems = (
  result: EnrollmentHistoryQuery,
): EnrollmentHistoryQuery["pastEnrollmentsForParentProfile"] =>
  result.pastEnrollmentsForParentProfile;

const getResult = (
  previousResult: EnrollmentHistoryQuery,
  fetchMoreResult: EnrollmentHistoryQuery,
): EnrollmentHistoryQuery => {
  return {
    pastEnrollmentsForParentProfile: [
      ...previousResult.pastEnrollmentsForParentProfile,
      ...fetchMoreResult.pastEnrollmentsForParentProfile,
    ],
  };
};

const hasMoreItems = (data: $TSFixMe) => data.length !== 6;

export const useEnrollmentHistoryQuery = (
  options: EnrollmentHistoryQueryOptions,
) => {
  const getFetchMoreVariables = (
    result: QueryResult<
      EnrollmentHistoryQuery,
      EnrollmentHistoryQueryVariables
    >,
  ): Partial<EnrollmentHistoryQueryVariables> => ({
    offset: result.data?.pastEnrollmentsForParentProfile.length,
    profileLinkUid: options.variables.profileLinkUid,
  });

  const {
    data,
    loading,
    error,
    fetchMore: fetchMoreEnrollmentHistory,
    isFetchingMore,
    hasMore,
  } = usePaginatedQuery(
    enrollmentHistoryQuery,
    options,
    getItems,
    getResult,
    getFetchMoreVariables,
    hasMoreItems,
  );

  return {
    data,
    loading,
    error,
    fetchMoreEnrollmentHistory,
    isFetchingMore,
    hasMore,
  };
};
